import React from 'react';
import './TrialContextBanner.css';

/**
 * TrialContextBanner - Shows clinical trial context when booking travel
 * Displays when user clicks "Book Travel" from a trial card
 */
const TrialContextBanner = ({ trialContext, onDismiss }) => {
  if (!trialContext) return null;

  return (
    <div className="trial-context-banner">
      <div className="trial-banner-content">
        <div className="trial-banner-icon">🏥</div>
        <div className="trial-banner-info">
          <div className="trial-banner-label">Booking travel for:</div>
          <div className="trial-banner-title">{trialContext.trialName}</div>
          <div className="trial-banner-details">
            {trialContext.trialId && (
              <span className="trial-banner-meta">{trialContext.trialId}</span>
            )}
            {trialContext.destination && trialContext.destinationState && (
              <span className="trial-banner-meta">
                📍 {trialContext.destination}, {trialContext.destinationState}
              </span>
            )}
            {trialContext.facilityName && (
              <span className="trial-banner-meta">
                🏥 {trialContext.facilityName}
              </span>
            )}
            {trialContext.sponsor && (
              <span className="trial-banner-meta">
                💊 {trialContext.sponsor}
              </span>
            )}
            {trialContext.phase && (
              <span className="trial-banner-meta">
                {trialContext.phase}
              </span>
            )}
          </div>
        </div>
        {onDismiss && (
          <button className="trial-banner-close" onClick={onDismiss} title="Dismiss">
            ×
          </button>
        )}
      </div>
    </div>
  );
};

export default TrialContextBanner;